import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { MatDialog } from "@angular/material";
import { AppService } from "src/_services/app.service";
import { Router, ActivatedRoute } from "@angular/router";
import { MatDatepickerInputEvent } from "@angular/material";
import * as moment from "moment";
import { roleTypeGroup } from "src/_constants/roleType";

export interface DialogData {
  eventId: string;
  sportId: string;
  providerId: string;
  marketId: string;
  marketType: string;
  rollbackType: string;
}

@Component({
  selector: 'app-sr-events',
  templateUrl: './sr-events.component.html',
  styleUrls: ['./sr-events.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SrEventsComponent implements OnInit {
  providers: any = [];
  ProviderId: string = "BetFair";
  sportsList = [];
  showAlert: boolean = false;
  eventsList = [];
  filteredevents = [];
  searchKey = "";
  sportId;
  sportName: string = "";
  selectedStatus = "";
  searchWord: string = "";
  selectedRunnerName = "";
  limit = 0;
  tabIndex;
  start: any;
  end: any;
  selected: any = {
    startDate: null,

    endDate: null,
  };
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [moment(this.startOfDay), moment(this.endOfDay)],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  eventsTableColumns = [
    "Open Date",
    "Event Name",
    "Open Bets",
    "Open Markets",
    "Settled Markets",
    "Voided Markets",
    "Other Markets",
    "Total Markets",
  ];
  constructor(
    private appService: AppService,
    private router: Router,
    private activetedRoute: ActivatedRoute,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.selected.startDate = moment(
      new Date(new Date().setDate(new Date().getDate() - 1))
    );
    this.selected.endDate = moment(
      new Date(new Date().setDate(new Date().getDate() + 1))
    );
    this.activetedRoute.queryParams.subscribe((params) => {
      this.ProviderId = params["providerId"];
      this.sportId = params["sportId"];
      this.sportName = params["sportName"];
      this.start = params["startDate"];
      this.end = params["endDate"];
    });
    if (this.start !== undefined && this.end !== undefined) {
      this.selected.startDate = moment(parseInt(this.start));
      this.selected.endDate = moment(parseInt(this.end));
    }
    if (this.ProviderId && this.sportId) {
      this.getOurProviders();
      if (this.ProviderId) {
        this.getSportsByProvider(this.ProviderId);
      }
    } else {
      this.getOurProviders();
      if (this.ProviderId) {
        this.getSportsByProvider(this.ProviderId);
      }
    }
    if (this.ProviderId && this.sportId) {
      this.limit = 2;
      this.getSettlementEvents();
    }
  }

  onSelectedStatusTab(selectedProvider) {
    if (this.limit < 1) {
      this.eventsList = [];
      this.ProviderId = selectedProvider;
      this.sportId = "";
      this.getSportsByProvider(this.ProviderId);
    } else if (this.limit === 3) {
      this.limit = 0;
    } else {
      const index = this.providers.findIndex(
        (provider) => provider.ProviderId === this.ProviderId
      );
      this.tabIndex = index;
      this.limit = 3;
      if (this.tabIndex === 0) {
        this.limit = 0;
      }
    }
  }

  getOurProviders() {
    try {
      this.appService.getOurProviders().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.providers = res.providers;
          if (roleTypeGroup.includes(this.userRole.role)) {
            this.providers = res.providers.filter(
              (provider) => provider.ProviderId === "SportRadar"
            );
          }
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.selected.endDate) {
      let start = this.selected.startDate;
      let end = this.selected.endDate;
      let diff = end.diff(start, "days") + 1;
      if (diff > 15) {
        this.showAlert = true;
        this.selected.startDate = moment(
          new Date(new Date().setDate(new Date().getDate() - 8))
        );
        this.selected.endDate = moment(
          new Date(new Date().setDate(new Date().getDate() + 7))
        );
        setTimeout(() => {
          this.showAlert = false;
        }, 3000);
      } else if (this.selected.startDate !== null && this.sportId !== "") {
        this.getSettlementEvents();
      }
    }
  };

  onSelectedSportName(Sport) {
    this.sportId = Sport.SportId;
    this.sportName = Sport.SportName;
    this.getSettlementEvents();
  }

  getSportsByProvider(providerId) {
    try {
      this.appService.getSportForBetList(providerId).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.sportsList = res.sports;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  searchHandlerChange() {
    if (this.searchKey.length >= 1) {
      this.eventsList = this.filteredevents.filter((event) => {
        if (
          event.eventName
            .toLocaleLowerCase()
            .includes(this.searchKey.toLocaleLowerCase())
        ) {
          return event;
        }
      });
    } else {
      this.eventsList = this.filteredevents;
    }
  }

  getSettlementEvents() {
    try {
      this.appService
        .getEventsForSettlemets(
          this.ProviderId,
          this.sportId,
          Number(
            (this.selected.startDate.valueOf() / 1000).toString().split(".")[0]
          ),
          Number(
            (this.selected.endDate.valueOf() / 1000).toString().split(".")[0]
          )
        )
        .subscribe((response) => {
          this.filteredevents = [];
          this.eventsList = [];
          this.eventsList = response.events.sort(
            (a, b) => b.openBets - a.openBets
          );
          this.filteredevents = this.eventsList;
        });
    } catch (err) {
      console.log(err);
    }
  }

  goToMarketsPage(event) {
    this.router.navigate(["surveillance/sr_bets_settlement"], {
      queryParams: {
        providerId: this.ProviderId,
        sportId: event.sportsId,
        eventId: event.eventId,
        eventName: event.eventName,
        sportName: event.sportName,
        openDate: event.openDate,
        startDate: this.selected.startDate,
        endDate: this.selected.endDate,
      },
    });
  }

  convertDate(date) {
    return moment(date).format("DD MMM YYYY hh:mm:ss A");
  }
}
